/*
 * @Desc: store
 * @Author: zcc
 * @Date: 2022-11-03 17:09:53
 * @LastEditors: zcc
 * @LastEditTime: 2022-11-22 16:50:06
 */
import { createStore } from 'vuex'
import { getUserInfo, getCodeToken, logout } from '@/api/user'
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    interfacegGetUserInfo ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then((res) => {
          sessionStorage.setItem('info', JSON.stringify(res))
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    interfacegGetCodeToken ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        getCodeToken(data).then((res) => {
          sessionStorage.setItem('token', res.token)
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    interfaceLogout({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        logout().then((res) => {
          sessionStorage.clear()
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  modules: {
  }
})
